<template>
    <div class="workordrAssign workerGddb">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>督办工单，并推送至承办单位
        </div>
        <div class="workordr_content">
            <el-form label-width="120px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef"
            >
                <div class="workordr_main">
                    <div>
                        <el-form-item label="督办内容" prop="czCzjgwb">
                            <el-input maxlength="2000" :autosize="{ minRows: 5}" v-model="ruleForm.czCzjgwb" show-word-limit type="textarea"/>
                        </el-form-item>
                        <Workorder_file paddingLeft="120" @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>
                        <!--<div class="workordr_footer">-->
                            <!--<div class="workordr_footer_zpcbdw">-->
                                <!--转派承办单位-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance} from 'vue'
    import {ElMessageBox,ElLoading} from 'element-plus'
    import {useStore} from 'vuex';
    import Workorder_file from './Wordorder_file.vue';

    export default {
        name: "Workorder_SQTH",
        props: ["gdId","thqx"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'GDDB',
                "gdId": props.gdId,
                "czCzjgwb": "",
                "fileIds":[],
            });
            const rules = reactive({

            });
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent", "gddb");
                                        // store.state.addNewWorkorderSuccess=true;
                                        // context.emit("workerGddbCancle");
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };

            //取消事件
            const cancleClick=()=>{
                context.emit("workerGddbCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })

            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            onMounted(() => {
            });
            return {
                ruleForm,
                rules,
                ruleFormRef,
                submitForm,
                cancleClick,
                fileListToParent,
                deleteFile
            }
        }
    }
</script>

<style scoped>
    .workordrAssign.workerGddb{
        margin-bottom: 12px;
        padding:12px 16px 0 16px;
        background: #F6F8FD;
    }
</style>
